// src/types.ts
var SURFACE_IDS = [
  "home",
  "pipeline",
  "calendar",
  "data",
  "orgchart",
  "learn",
  "crm",
  "mail",
  "projects",
  "marketing",
  "finance",
  "growth",
  "portal",
  "connections",
  "agents",
  "templates",
  "ops",
  "clients",
  "advisors",
  "leads",
  "reports",
  "social",
  "workorders",
  "schedule",
  "proof",
  "repeat",
  "inbox",
  "work",
  "deadlines",
  "documents",
  "meetings",
  "billing",
  "builder",
  "proposals",
  "briefings",
  "propertychecks",
  "clientfiles",
  "sales",
  "retailers",
  "budget",
  "forecast",
  "brands",
  "stock",
  "claims",
  "monthend",
  "people",
  "scorecard",
  "industry",
  "front-door",
  "team",
  "brand",
  "health",
  "strategies",
  "notifications"
];

// src/defineInstance.ts
var InstanceConfigError = class extends Error {
  constructor(message) {
    super(`[instance] ${message}`);
    this.name = "InstanceConfigError";
  }
};
var SLUG_RE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
function defineInstance(instance) {
  if (!instance.slug || !SLUG_RE.test(instance.slug)) {
    throw new InstanceConfigError(
      `slug must be kebab-case ([a-z0-9-]), got "${instance.slug}"`
    );
  }
  if (!instance.displayName || !instance.displayName.trim()) {
    throw new InstanceConfigError(`"${instance.slug}": displayName is required`);
  }
  if (!instance.theme || !instance.theme.accent || !instance.theme.accent.trim()) {
    throw new InstanceConfigError(`"${instance.slug}": theme.accent is required`);
  }
  if (!Array.isArray(instance.modules) || instance.modules.length === 0) {
    throw new InstanceConfigError(
      `"${instance.slug}": modules must list at least one surface`
    );
  }
  const seen = /* @__PURE__ */ new Set();
  for (const id of instance.modules) {
    if (!SURFACE_IDS.includes(id)) {
      throw new InstanceConfigError(
        `"${instance.slug}": unknown module "${id}" (valid: ${SURFACE_IDS.join(", ")})`
      );
    }
    if (seen.has(id)) {
      throw new InstanceConfigError(`"${instance.slug}": duplicate module "${id}"`);
    }
    seen.add(id);
  }
  const fd = instance.frontDoor;
  if (fd && (fd.home || fd.apps) && !fd.domain) {
    throw new InstanceConfigError(`"${instance.slug}": frontDoor.home and frontDoor.apps need frontDoor.domain`);
  }
  const checkModules = (where, list) => {
    for (const id of list) {
      if (!SURFACE_IDS.includes(id)) {
        throw new InstanceConfigError(`"${instance.slug}": unknown module "${id}" in ${where}`);
      }
    }
  };
  if (fd?.home) checkModules("frontDoor.home.modules", fd.home.modules);
  const appSlugs = /* @__PURE__ */ new Set();
  for (const app of fd?.apps ?? []) {
    if (!SLUG_RE.test(app.slug) || !SLUG_RE.test(app.subdomain)) {
      throw new InstanceConfigError(`"${instance.slug}": frontDoor app "${app.slug}" needs a kebab-case slug and subdomain`);
    }
    if (appSlugs.has(app.slug)) {
      throw new InstanceConfigError(`"${instance.slug}": duplicate frontDoor app "${app.slug}"`);
    }
    appSlugs.add(app.slug);
    checkModules(`frontDoor.apps["${app.slug}"].modules`, app.modules);
  }
  return Object.freeze({
    ...instance,
    theme: Object.freeze({ ...instance.theme }),
    modules: Object.freeze([...instance.modules]),
    copy: instance.copy ? Object.freeze({ ...instance.copy }) : void 0,
    entry: instance.entry ? Object.freeze({ ...instance.entry }) : void 0,
    ...instance.frontDoor ? {
      frontDoor: Object.freeze({
        ...instance.frontDoor,
        ...instance.frontDoor.providers ? { providers: Object.freeze([...instance.frontDoor.providers]) } : {}
      })
    } : {}
  });
}

export { InstanceConfigError, SURFACE_IDS, defineInstance };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map